import { UI } from '@genial/components';
import { BoxBorder, Color } from '@genial/design-tokens';
import { Modal, ScrollView } from 'native-base';
import { Dimensions } from 'react-native';
import { useRecoilValue } from 'recoil';

import { useRecoilQuery } from '../../../../../../../../../hooks/useRecoilQuery';
import { fundsOfferDocumentsQuery } from '../../../../../../../../../store/availableProducts/selectors/funds';
import { useFundsAssetContext } from '../../../../../../../../BatchTicket/components/DynamicAsset/contexts/products/Funds';
import { useGlobalProductContext } from '../../../../../contexts';

import {
  formatDocumentList,
  formatFundsDetailsData,
  formatFundsExtraDetailsData,
} from './constants';

export const ItemDetails = () => {
  const { height } = Dimensions.get('window');

  const { product } = useGlobalProductContext();
  const marketStatus = useRecoilValue(product.marketStatusSelector);

  const { modalOpen, offerSelected, setModalOpen } = useFundsAssetContext();

  const {
    data: documentsData,
    loading: documentsLoading,
    error: documentsError,
  } = useRecoilQuery(
    fundsOfferDocumentsQuery({
      internalProductId: offerSelected?.externalId?.toString() || '',
    })
  );

  if (!offerSelected) {
    return <></>;
  }

  const getOfferCaptions = () => {
    return product.captions
      .filter(({ icon }) => offerSelected.captions?.includes(icon))
      .map((caption) => ({ ...caption, iconColor: Color[caption.iconColor] }));
  };

  return (
    <UI.Modal isOpen={modalOpen} onClose={() => setModalOpen(false)} testId="modal-details">
      <Modal.Content
        alignItems={'center'}
        w={'full'}
        maxH={{ base: height * 0.75, lg: 'full' }}
        maxW={{ base: 'full', lg: '909px' }}
        marginBottom={{ base: 0, lg: 'none' }}
        marginTop={{ base: 'auto', lg: 0 }}
        borderRadius={BoxBorder.heavy}>
        <ScrollView w={'full'} showsVerticalScrollIndicator={false}>
          <UI.FundsDetails
            testId={'modal-funds-details'}
            initials={offerSelected?.productNameNormalized?.substring(0, 2).toUpperCase() || '--'}
            title={offerSelected?.productNameNormalized || '--'}
            isMarketClosed={marketStatus.isOpen}
            marketStatus={marketStatus.message}
            onClose={() => setModalOpen(false)}
            captions={getOfferCaptions()}
            data={formatFundsDetailsData(offerSelected as any)}
            extraData={formatFundsExtraDetailsData(offerSelected as any)}
            downloadList={formatDocumentList(documentsData || undefined)}
            isError={!!documentsError}
            isLoading={documentsLoading}
            maxW={{ base: 'full', lg: '909px' }}
          />
        </ScrollView>
      </Modal.Content>
    </UI.Modal>
  );
};
